
import React from 'react';
import { History } from 'lucide-react';

interface CustomerSelectionHeaderProps {
  hasLastActiveCustomer: boolean;
}

const CustomerSelectionHeader: React.FC<CustomerSelectionHeaderProps> = ({ 
  hasLastActiveCustomer
}) => {
  if (!hasLastActiveCustomer) return null;
  return (
    <div className="flex items-center justify-center gap-1 mt-2 text-sm">
      <History className="h-4 w-4 text-muted-foreground" />
      <span className="text-muted-foreground">Your last used customer is highlighted</span>
    </div>
  );
};

export default CustomerSelectionHeader;
